import { Line as Container } from "./styles";

export function EmptyLine() {
  return <Container />;
}
